module.exports = __webpack_public_path__ + "img/quotes.eaeb7c3a.svg";